<template>
  <div
    class="daily-performance-chart bg-white shadow rounded-lg p-4" style="padding: 5px;"
    :class="{ 'daily-performance-chart--dark': $store.getters.isDark }"
  >
    <!-- <h2 class="daily-performance-chart__header">
      {{ totalRequests }} Requests Processed Today
    </h2> -->

    <div
      v-if="totalRequests > 0"
      class="daily-performance-chart__bar h-2 rounded-full flex overflow-hidden"
    >
      <div
        v-for="(item, index) in performanceData"
        :key="index"
        class="daily-performance-chart__segment"
        :style="segmentStyle(item)"
      />
    </div>

    <div v-if="totalRequests > 0" class="daily-performance-chart__details">
      <!-- <div class="daily-performance-chart__details-title">
        DAILY PERFORMANCE DETAILS
      </div> -->
      <div class="daily-performance-chart__legend-list">
        <div
          v-for="(item, index) in performanceData"
          :key="index"
          class="daily-performance-chart__legend-row"
        >
          <span
            class="daily-performance-chart__legend-dot w-3 h-3 rounded-full"
            :style="{ backgroundColor: item.color }"
          />
          <span class="daily-performance-chart__legend-name">{{ displayLabel(item.name) }}</span>
          <span class="daily-performance-chart__legend-value">{{ item.value }}</span>
        </div>
      </div>
    </div>

    <div v-else class="daily-performance-chart__empty">
      لا توجد طلبات معالجة اليوم
    </div>
  </div>
</template>

<script>
export default {
  name: 'DailyPerformanceChart',
  props: {
    performanceData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    totalRequests() {
      if (!Array.isArray(this.performanceData) || this.performanceData.length === 0) {
        return 0;
      }
      return this.performanceData.reduce((sum, item) => {
        const val = Number(item.value);
        return sum + (Number.isFinite(val) ? val : 0);
      }, 0);
    },
  },
  methods: {
    displayLabel(name) {
      const labels = {
        Received: "المستلمة",
        New: "الطلبات الجديدة",
        Followed: "المتابعة",
        Archived: "المؤرشفة",
        Completed: "المكتملة",
      };
      return labels[name] || name;
    },
    segmentWidth(item) {
      if (this.totalRequests <= 0) return 0;
      const val = Number(item.value);
      const value = Number.isFinite(val) ? val : 0;
      return (value / this.totalRequests) * 100;
    },
    segmentStyle(item) {
      const width = this.segmentWidth(item);
      return {
        width: `${width}%`,
        backgroundColor: item.color || '#6B7280',
      };
    },
  },
};
</script>

<style scoped>
.daily-performance-chart {
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  border-radius: 0.5rem;
  padding: 1rem;
}

.daily-performance-chart__header {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  color: #1f2937;
}

.daily-performance-chart__bar {
  display: flex;
  height: 0.5rem;
  border-radius: 9999px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.daily-performance-chart__segment {
  flex-shrink: 0;
  min-width: 0;
  transition: width 0.2s ease;
}

.daily-performance-chart__details {
  margin-top: 0.5rem;
}

.daily-performance-chart__details-title {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: #6b7280;
  margin-bottom: 0.5rem;
}

.daily-performance-chart__legend-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.5rem;
}

.daily-performance-chart__legend-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0;
  font-size: 0.875rem;
}

.daily-performance-chart__legend-dot {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 9999px;
  flex-shrink: 0;
}

.daily-performance-chart__legend-name {
  color: #374151;
}

.daily-performance-chart__legend-value {
  font-weight: 500;
  color: #1f2937;
}

.daily-performance-chart__empty {
  font-size: 0.875rem;
  color: #6b7280;
  padding: 0.5rem 0;
}

/* Dark mode */
.daily-performance-chart--dark.daily-performance-chart,
.daily-performance-chart--dark.bg-white {
  background-color: #1f2937;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.3);
}

.daily-performance-chart--dark .daily-performance-chart__header {
  color: #e5e7eb;
}

.daily-performance-chart--dark .daily-performance-chart__details-title {
  color: #9ca3af;
}

.daily-performance-chart--dark .daily-performance-chart__legend-name {
  color: #d1d5db;
}

.daily-performance-chart--dark .daily-performance-chart__legend-value {
  color: #f3f4f6;
}

.daily-performance-chart--dark .daily-performance-chart__empty {
  color: #9ca3af;
}

/* Tailwind-like utilities used by template */
.bg-white {
  background-color: #fff;
}
.shadow {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}
.rounded-lg {
  border-radius: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.h-2 {
  height: 0.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.flex {
  display: flex;
}
.overflow-hidden {
  overflow: hidden;
}
.w-3 {
  width: 0.75rem;
}
.h-3 {
  height: 0.75rem;
}
</style>
